import React from "react";
import { SignupOptions } from "./SignupOptions";
import { SignupForm } from "./SignupForm";
import { SignupFormActions } from "./SignupFormActions";
import { COLLTRAIN_LOGO_MEDIUM } from '../../../../../global/dist/constants';
import { IApplicationContext } from "../context";
import { observer } from "mobx-react-lite";
import { Icon } from "@blueprintjs/core";

/**
 * Main
 */
export const Main: React.FunctionComponent<IApplicationContext> = props => {


	return (
		<main className='signup-container'>
			<div className="logo">
				<a href="/auth/login">
					<img src={COLLTRAIN_LOGO_MEDIUM} />
				</a>
			</div>

			{!!props.store.data.initData.email ? (
				<div className='signup-wrapper'>

					<div className='signup-heading'>
						<h2>Sign Up</h2>
					</div>

					<SignupForm {...props} />
					<SignupFormActions {...props} />

					<ErrorDialog {...props} />
				</div>
			) : (
				<div className='signup-wrapper'>
					<div className='signup-heading'>
						<div className="auth-signin">
							<div>Already have an account?</div>
							<a href="/auth/login">Sign In</a>
						</div>

						<h2>Sign Up</h2>
					</div>

					<p>
						Sign up free with a Hobby plan, upgrade later.
					</p>

					<SignupOptions {...props} />

					<ErrorDialog {...props} />
				</div>
			)}
		</main>
	)
}

// ErrorDialog
const ErrorDialog: React.FunctionComponent<IApplicationContext> = observer(props => {

	if (!props.store.data.meta.data.error) return null;

	const onAck = () => props.store.data.meta.set('error', null);

	// --

	return (
		<div className="uk-position-cover uk-overlay uk-overlay-default">
			<div className="uk-position-center uk-padding-small">
				<div className="uk-width-large ">
					<div className="uk-alert-danger uk-alert">
						<div className="uk-flex uk-flex-top">
							<div className="uk-flex-0 uk-margin-right">
								<Icon icon='warning-sign' size={26} />
							</div>

							<div className="uk-flex-1" style={{ fontSize: 15 }}>
								{props.store.data.meta.data.error}
							</div>

							<div className="uk-flex-0 uk-margin-left">
								<button className="uk-button uk-button-danger uk-button-small" onClick={onAck}>OK</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
})
